import { parseQueryParamsObject, sentryLogger } from "@robe/core-utils";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

export interface MatchRouteResponse {
  type: "NotFound" | "Rewrite" | "Redirect" | "External";
  path: string;
}

/**
 * Matches route to the routes available in DB.
 *
 * @param urlOrRoute Request url or route without the trailing slash.
 * @param core The XcoreCore instance.
 */
export const matchRoute = (urlOrRoute: string, core: XcoreCore): BaseApiRequest<MatchRouteResponse> => {
  sentryLogger({
    type: "debug",
    debugBlock: "routing",
    context: {
      matchRouteProvidedRoute: urlOrRoute,
    },
  });

  return core.fetch(`/api/route/match${parseQueryParamsObject({ url: urlOrRoute })}`).then((res) => res.json());
};
